import { Icon, type IconProps } from "./icon";

/** The theme: paper and carbon, following the system. */
export function ThemeIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="10" cy="10" r="6.25" />
      <path d="M10 3.75v12.5a6.25 6.25 0 0 0 0-12.5z" fill="currentColor" stroke="none" />
    </Icon>
  );
}
